import _ from 'underscore';
import queryString from 'query-string';
import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
  FetchPolicy,
} from '@bingads-webui-react/overreact';
import type { RequestFactoryContext } from '@bingads-webui-react/overreact';

import { schema } from '../../../environment/schema';
import { getDefaultOptions } from '../../../request-contract-helper/index';
import type { Account, AccountVariables } from '../../../types';

function ccUrlFactory(params: RequestFactoryContext<AccountVariables, null>) {
  const { variables } = params;

  const {
    locator,
  } = variables;

  const { descriptor } = locator;
  const { uid, cid, aid } = descriptor;

  const search = {
    uid,
    cid,
    id: aid,
  };

  const searchString = _.isEmpty(search) ? '' : `?${queryString.stringify(search)}`;

  return `cc/API/Account${searchString}`;
}

function ccOptionsFactory() {
  return getDefaultOptions();
}

export const fetchRequestContract = createRequestContract<AccountVariables, null>({
  schema,
  dataPath: 'user:customer:account',
  verb: requestVerbs.GET,
  fetchPolicy: FetchPolicy.StoreOrNetwork,
  uriFactoryFn: ccUrlFactory,

  headerFactoryFn: ccOptionsFactory,

  keySelector: variables => variables.locator.descriptor.aid,

  parentKeySelector: variables => variables.locator.descriptor.cid,
});

export const fetchResponseContract = createResponseContract<
  AccountVariables,
  null,
  Account,
  Account,
  Account
>({
  requestContract: fetchRequestContract,
  responseType: responseTypes.ENTITY,

  keySelector: account => account.id,
  processorFn: response => response,
});
